// This file was automatically generated from data.physicians.html.
// Please don't edit this file by hand.

goog.provide('el8.template.data.physicians');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.data.physicians.icon = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<span>', (el8Globals.FEATURES.PLR4Everyone) ? '<img ' + ((opt_data.isActivePlr && opt_data.isSharingPlr) ? 'class="el8CardPhoto el8CardFullPlr"' : (opt_data.isActivePlr) ? 'class="el8CardPhoto el8CardPartialPlr"' : (opt_data.isSharingPlr) ? 'class="el8CardPhoto el8CardPartialPlr"' : (opt_data.isInvitePendingPlr) ? 'class="el8CardPhoto el8CardPending"' : 'class="el8CardPhoto"') : '<img class="el8CardPhoto"', (opt_data.isNotMapped) ? ' src="/static/images/photo_unknown.png"' : (opt_data.accessUserId) ? ' src="/user/' + soy.$$escapeHtml(opt_data.accessUserId) + '/photo/profile/24/24/"' : (opt_data.isOrg) ? ' src="/static/images/avatar_organization_sm.png"' : ' src="/static/images/user_photo_placeholder.png"', '/></span>', (el8Globals.FEATURES.PLR4Everyone) ? (opt_data.isActivePlr && opt_data.isSharingPlr) ? '<span class="el8PLRFullMark care-team-active-icon"></span>' : (opt_data.isActivePlr) ? '<span class="el8PLRAccessOnlyMark care-team-active-not-sharing-icon"></span>' : (opt_data.isSharingPlr) ? '<span class="el8PLRSharingOnlyMark care-team-inactive-and-sharing-icon"></span>' : (opt_data.isInvitePendingPlr) ? '<span class="el8PLRInvitePendingMark care-team-invite-outstanding-icon">Invited</span>' : '' : '', (opt_data.providerLogo == 'emr') ? '<span class="emr-user-icon el8MRElationMark"></span>' : (opt_data.providerLogo == 'passport') ? '<span class="passport-user-icon el8MRPassportMark"></span>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.data.physicians.verifiedCheck = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<span class="verified-icon el8MRVerifiedMark"></span>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.data.physicians.specialtyList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.specialties && opt_data.specialties.length) {
    var sList10284 = opt_data.specialties;
    var sListLen10284 = sList10284.length;
    for (var sIndex10284 = 0; sIndex10284 < sListLen10284; sIndex10284++) {
      var sData10284 = sList10284[sIndex10284];
      output.append(soy.$$escapeHtml(sData10284.name), (! (sIndex10284 == sListLen10284 - 1)) ? ', ' : '');
    }
  }
  if (!opt_sb) return output.toString();
};
